import { render, staticRenderFns } from "./CaseShow.vue?vue&type=template&id=0db5eda1&scoped=true"
import script from "./CaseShow.vue?vue&type=script&lang=js"
export * from "./CaseShow.vue?vue&type=script&lang=js"
import style0 from "./CaseShow.vue?vue&type=style&index=0&id=0db5eda1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db5eda1",
  null
  
)

export default component.exports